// source: v2/types/number.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var v2_types_utility_pb = require('../../v2/types/utility_pb.js');
goog.object.extend(proto, v2_types_utility_pb);
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
goog.exportSymbol('proto.loopup.ctgateway.v2.AllocationStatus', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.CTAllocationStatus', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.CTNumber', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.CTNumberSortDirection', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.CTNumberSortProperty', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.CTNumberType', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.DDI', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.DDISortProperty', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.HostType', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.NumberPendingChanges', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.NumberPendingChanges.AllocationStatusEnumCase', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.NumberPendingChanges.DdiNumberTypeEnumCase', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.NumberPendingChanges.HostTypeEnumCase', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.NumberPendingChanges.NumberStatusEnumCase', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.NumberPendingChanges.SupplierEnumCase', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.NumberPendingChanges.UsageTypeEnumCase', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.NumberPendingChanges.UserTypeEnumCase', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.NumberStatus', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.NumberType', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.OculeusSyncStatus', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.RibbonSyncStatus', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.Supplier', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.UsageType', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.UserType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.DDI = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.DDI, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.DDI.displayName = 'proto.loopup.ctgateway.v2.DDI';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.CTNumber = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.CTNumber, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.CTNumber.displayName = 'proto.loopup.ctgateway.v2.CTNumber';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.NumberPendingChanges = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_);
};
goog.inherits(proto.loopup.ctgateway.v2.NumberPendingChanges, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.NumberPendingChanges.displayName = 'proto.loopup.ctgateway.v2.NumberPendingChanges';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.DDI.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.DDI.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.DDI} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.DDI.toObject = function(includeInstance, msg) {
  var f, obj = {
    e164: jspb.Message.getFieldWithDefault(msg, 1, ""),
    allocationStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    numberType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    country: (f = msg.getCountry()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    city: (f = msg.getCity()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    siteName: (f = msg.getSiteName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    assignedUser: (f = msg.getAssignedUser()) && v2_types_utility_pb.NullableString.toObject(includeInstance, f),
    ddiNumberType: jspb.Message.getFieldWithDefault(msg, 8, 0),
    assignedUserName: (f = msg.getAssignedUserName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    hostType: jspb.Message.getFieldWithDefault(msg, 10, 0),
    usageType: jspb.Message.getFieldWithDefault(msg, 11, 0),
    siteId: jspb.Message.getFieldWithDefault(msg, 12, ""),
    userPrincipalName: (f = msg.getUserPrincipalName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    drNumber: (f = msg.getDrNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    sipTrunkName: (f = msg.getSipTrunkName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.DDI}
 */
proto.loopup.ctgateway.v2.DDI.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.DDI;
  return proto.loopup.ctgateway.v2.DDI.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.DDI} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.DDI}
 */
proto.loopup.ctgateway.v2.DDI.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setE164(value);
      break;
    case 2:
      var value = /** @type {!proto.loopup.ctgateway.v2.AllocationStatus} */ (reader.readEnum());
      msg.setAllocationStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumberType(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCountry(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCity(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSiteName(value);
      break;
    case 7:
      var value = new v2_types_utility_pb.NullableString;
      reader.readMessage(value,v2_types_utility_pb.NullableString.deserializeBinaryFromReader);
      msg.setAssignedUser(value);
      break;
    case 8:
      var value = /** @type {!proto.loopup.ctgateway.v2.NumberType} */ (reader.readEnum());
      msg.setDdiNumberType(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAssignedUserName(value);
      break;
    case 10:
      var value = /** @type {!proto.loopup.ctgateway.v2.HostType} */ (reader.readEnum());
      msg.setHostType(value);
      break;
    case 11:
      var value = /** @type {!proto.loopup.ctgateway.v2.UsageType} */ (reader.readEnum());
      msg.setUsageType(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setUserPrincipalName(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDrNumber(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSipTrunkName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.DDI.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.DDI.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.DDI} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.DDI.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getE164();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAllocationStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getNumberType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCountry();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCity();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSiteName();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getAssignedUser();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      v2_types_utility_pb.NullableString.serializeBinaryToWriter
    );
  }
  f = message.getDdiNumberType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getAssignedUserName();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getHostType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getUsageType();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getUserPrincipalName();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDrNumber();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSipTrunkName();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string e164 = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.DDI.prototype.getE164 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
 */
proto.loopup.ctgateway.v2.DDI.prototype.setE164 = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional AllocationStatus allocation_status = 2;
 * @return {!proto.loopup.ctgateway.v2.AllocationStatus}
 */
proto.loopup.ctgateway.v2.DDI.prototype.getAllocationStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.AllocationStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.AllocationStatus} value
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
 */
proto.loopup.ctgateway.v2.DDI.prototype.setAllocationStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string number_type = 3;
 * @return {string}
 */
proto.loopup.ctgateway.v2.DDI.prototype.getNumberType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
 */
proto.loopup.ctgateway.v2.DDI.prototype.setNumberType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue country = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.DDI.prototype.getCountry = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
*/
proto.loopup.ctgateway.v2.DDI.prototype.setCountry = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
 */
proto.loopup.ctgateway.v2.DDI.prototype.clearCountry = function() {
  return this.setCountry(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.DDI.prototype.hasCountry = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue city = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.DDI.prototype.getCity = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
*/
proto.loopup.ctgateway.v2.DDI.prototype.setCity = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
 */
proto.loopup.ctgateway.v2.DDI.prototype.clearCity = function() {
  return this.setCity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.DDI.prototype.hasCity = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue site_name = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.DDI.prototype.getSiteName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
*/
proto.loopup.ctgateway.v2.DDI.prototype.setSiteName = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
 */
proto.loopup.ctgateway.v2.DDI.prototype.clearSiteName = function() {
  return this.setSiteName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.DDI.prototype.hasSiteName = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional NullableString assigned_user = 7;
 * @return {?proto.loopup.ctgateway.v2.NullableString}
 */
proto.loopup.ctgateway.v2.DDI.prototype.getAssignedUser = function() {
  return /** @type{?proto.loopup.ctgateway.v2.NullableString} */ (
    jspb.Message.getWrapperField(this, v2_types_utility_pb.NullableString, 7));
};


/**
 * @param {?proto.loopup.ctgateway.v2.NullableString|undefined} value
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
*/
proto.loopup.ctgateway.v2.DDI.prototype.setAssignedUser = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
 */
proto.loopup.ctgateway.v2.DDI.prototype.clearAssignedUser = function() {
  return this.setAssignedUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.DDI.prototype.hasAssignedUser = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional NumberType ddi_number_type = 8;
 * @return {!proto.loopup.ctgateway.v2.NumberType}
 */
proto.loopup.ctgateway.v2.DDI.prototype.getDdiNumberType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.NumberType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.NumberType} value
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
 */
proto.loopup.ctgateway.v2.DDI.prototype.setDdiNumberType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional google.protobuf.StringValue assigned_user_name = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.DDI.prototype.getAssignedUserName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
*/
proto.loopup.ctgateway.v2.DDI.prototype.setAssignedUserName = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
 */
proto.loopup.ctgateway.v2.DDI.prototype.clearAssignedUserName = function() {
  return this.setAssignedUserName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.DDI.prototype.hasAssignedUserName = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional HostType host_type = 10;
 * @return {!proto.loopup.ctgateway.v2.HostType}
 */
proto.loopup.ctgateway.v2.DDI.prototype.getHostType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.HostType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.HostType} value
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
 */
proto.loopup.ctgateway.v2.DDI.prototype.setHostType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional UsageType usage_type = 11;
 * @return {!proto.loopup.ctgateway.v2.UsageType}
 */
proto.loopup.ctgateway.v2.DDI.prototype.getUsageType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.UsageType} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.UsageType} value
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
 */
proto.loopup.ctgateway.v2.DDI.prototype.setUsageType = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional string site_id = 12;
 * @return {string}
 */
proto.loopup.ctgateway.v2.DDI.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
 */
proto.loopup.ctgateway.v2.DDI.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional google.protobuf.StringValue user_principal_name = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.DDI.prototype.getUserPrincipalName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
*/
proto.loopup.ctgateway.v2.DDI.prototype.setUserPrincipalName = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
 */
proto.loopup.ctgateway.v2.DDI.prototype.clearUserPrincipalName = function() {
  return this.setUserPrincipalName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.DDI.prototype.hasUserPrincipalName = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.StringValue dr_number = 14;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.DDI.prototype.getDrNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
*/
proto.loopup.ctgateway.v2.DDI.prototype.setDrNumber = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
 */
proto.loopup.ctgateway.v2.DDI.prototype.clearDrNumber = function() {
  return this.setDrNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.DDI.prototype.hasDrNumber = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue sip_trunk_name = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.DDI.prototype.getSipTrunkName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
*/
proto.loopup.ctgateway.v2.DDI.prototype.setSipTrunkName = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.DDI} returns this
 */
proto.loopup.ctgateway.v2.DDI.prototype.clearSipTrunkName = function() {
  return this.setSipTrunkName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.DDI.prototype.hasSipTrunkName = function() {
  return jspb.Message.getField(this, 15) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.CTNumber.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.CTNumber} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.CTNumber.toObject = function(includeInstance, msg) {
  var f, obj = {
    ddi: jspb.Message.getFieldWithDefault(msg, 1, ""),
    allocationStatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    countryCode: (f = msg.getCountryCode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    city: (f = msg.getCity()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    siteName: (f = msg.getSiteName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    ddiNumberType: jspb.Message.getFieldWithDefault(msg, 6, 0),
    assignedUserName: (f = msg.getAssignedUserName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    hostType: jspb.Message.getFieldWithDefault(msg, 8, 0),
    numberOwnedByLoopUp: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    leadNumber: (f = msg.getLeadNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    supplier: jspb.Message.getFieldWithDefault(msg, 11, 0),
    siteId: (f = msg.getSiteId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    customerName: (f = msg.getCustomerName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    customerId: (f = msg.getCustomerId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    numberStatus: jspb.Message.getFieldWithDefault(msg, 15, 0),
    drNumber: (f = msg.getDrNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    oculeusSyncStatus: jspb.Message.getFieldWithDefault(msg, 17, 0),
    ribbonSyncStatus: jspb.Message.getFieldWithDefault(msg, 18, 0),
    callerId: (f = msg.getCallerId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    serviceUserId: (f = msg.getServiceUserId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    userType: jspb.Message.getFieldWithDefault(msg, 21, 0),
    numberRange: (f = msg.getNumberRange()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    userPrincipalName: (f = msg.getUserPrincipalName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    usageType: jspb.Message.getFieldWithDefault(msg, 24, 0),
    sipTrunkName: (f = msg.getSipTrunkName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.CTNumber}
 */
proto.loopup.ctgateway.v2.CTNumber.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.CTNumber;
  return proto.loopup.ctgateway.v2.CTNumber.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.CTNumber} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.CTNumber}
 */
proto.loopup.ctgateway.v2.CTNumber.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDdi(value);
      break;
    case 2:
      var value = /** @type {!proto.loopup.ctgateway.v2.CTAllocationStatus} */ (reader.readEnum());
      msg.setAllocationStatus(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCountryCode(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCity(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSiteName(value);
      break;
    case 6:
      var value = /** @type {!proto.loopup.ctgateway.v2.CTNumberType} */ (reader.readEnum());
      msg.setDdiNumberType(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAssignedUserName(value);
      break;
    case 8:
      var value = /** @type {!proto.loopup.ctgateway.v2.HostType} */ (reader.readEnum());
      msg.setHostType(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNumberOwnedByLoopUp(value);
      break;
    case 10:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLeadNumber(value);
      break;
    case 11:
      var value = /** @type {!proto.loopup.ctgateway.v2.Supplier} */ (reader.readEnum());
      msg.setSupplier(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSiteId(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomerName(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomerId(value);
      break;
    case 15:
      var value = /** @type {!proto.loopup.ctgateway.v2.NumberStatus} */ (reader.readEnum());
      msg.setNumberStatus(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDrNumber(value);
      break;
    case 17:
      var value = /** @type {!proto.loopup.ctgateway.v2.OculeusSyncStatus} */ (reader.readEnum());
      msg.setOculeusSyncStatus(value);
      break;
    case 18:
      var value = /** @type {!proto.loopup.ctgateway.v2.RibbonSyncStatus} */ (reader.readEnum());
      msg.setRibbonSyncStatus(value);
      break;
    case 19:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCallerId(value);
      break;
    case 20:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setServiceUserId(value);
      break;
    case 21:
      var value = /** @type {!proto.loopup.ctgateway.v2.UserType} */ (reader.readEnum());
      msg.setUserType(value);
      break;
    case 22:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setNumberRange(value);
      break;
    case 23:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setUserPrincipalName(value);
      break;
    case 24:
      var value = /** @type {!proto.loopup.ctgateway.v2.UsageType} */ (reader.readEnum());
      msg.setUsageType(value);
      break;
    case 25:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSipTrunkName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.CTNumber.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.CTNumber} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.CTNumber.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDdi();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAllocationStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCountryCode();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCity();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSiteName();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDdiNumberType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getAssignedUserName();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getHostType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getNumberOwnedByLoopUp();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getLeadNumber();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSupplier();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getSiteId();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomerName();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomerId();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getNumberStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getDrNumber();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getOculeusSyncStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getRibbonSyncStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
  f = message.getCallerId();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getServiceUserId();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getUserType();
  if (f !== 0.0) {
    writer.writeEnum(
      21,
      f
    );
  }
  f = message.getNumberRange();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getUserPrincipalName();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getUsageType();
  if (f !== 0.0) {
    writer.writeEnum(
      24,
      f
    );
  }
  f = message.getSipTrunkName();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ddi = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getDdi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.setDdi = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional CTAllocationStatus allocation_status = 2;
 * @return {!proto.loopup.ctgateway.v2.CTAllocationStatus}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getAllocationStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.CTAllocationStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.CTAllocationStatus} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.setAllocationStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue country_code = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getCountryCode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
*/
proto.loopup.ctgateway.v2.CTNumber.prototype.setCountryCode = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.clearCountryCode = function() {
  return this.setCountryCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.hasCountryCode = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue city = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getCity = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
*/
proto.loopup.ctgateway.v2.CTNumber.prototype.setCity = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.clearCity = function() {
  return this.setCity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.hasCity = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue site_name = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getSiteName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
*/
proto.loopup.ctgateway.v2.CTNumber.prototype.setSiteName = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.clearSiteName = function() {
  return this.setSiteName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.hasSiteName = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional CTNumberType ddi_number_type = 6;
 * @return {!proto.loopup.ctgateway.v2.CTNumberType}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getDdiNumberType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.CTNumberType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.CTNumberType} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.setDdiNumberType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional google.protobuf.StringValue assigned_user_name = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getAssignedUserName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
*/
proto.loopup.ctgateway.v2.CTNumber.prototype.setAssignedUserName = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.clearAssignedUserName = function() {
  return this.setAssignedUserName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.hasAssignedUserName = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional HostType host_type = 8;
 * @return {!proto.loopup.ctgateway.v2.HostType}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getHostType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.HostType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.HostType} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.setHostType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional bool number_owned_by_loop_up = 9;
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getNumberOwnedByLoopUp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.setNumberOwnedByLoopUp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional google.protobuf.StringValue lead_number = 10;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getLeadNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 10));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
*/
proto.loopup.ctgateway.v2.CTNumber.prototype.setLeadNumber = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.clearLeadNumber = function() {
  return this.setLeadNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.hasLeadNumber = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Supplier supplier = 11;
 * @return {!proto.loopup.ctgateway.v2.Supplier}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getSupplier = function() {
  return /** @type {!proto.loopup.ctgateway.v2.Supplier} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.Supplier} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.setSupplier = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional google.protobuf.StringValue site_id = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getSiteId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
*/
proto.loopup.ctgateway.v2.CTNumber.prototype.setSiteId = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.clearSiteId = function() {
  return this.setSiteId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.hasSiteId = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.StringValue customer_name = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getCustomerName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
*/
proto.loopup.ctgateway.v2.CTNumber.prototype.setCustomerName = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.clearCustomerName = function() {
  return this.setCustomerName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.hasCustomerName = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.StringValue customer_id = 14;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getCustomerId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 14));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
*/
proto.loopup.ctgateway.v2.CTNumber.prototype.setCustomerId = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.clearCustomerId = function() {
  return this.setCustomerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.hasCustomerId = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional NumberStatus number_status = 15;
 * @return {!proto.loopup.ctgateway.v2.NumberStatus}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getNumberStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.NumberStatus} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.NumberStatus} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.setNumberStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional google.protobuf.StringValue dr_number = 16;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getDrNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 16));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
*/
proto.loopup.ctgateway.v2.CTNumber.prototype.setDrNumber = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.clearDrNumber = function() {
  return this.setDrNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.hasDrNumber = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional OculeusSyncStatus oculeus_sync_status = 17;
 * @return {!proto.loopup.ctgateway.v2.OculeusSyncStatus}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getOculeusSyncStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.OculeusSyncStatus} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.OculeusSyncStatus} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.setOculeusSyncStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional RibbonSyncStatus ribbon_sync_status = 18;
 * @return {!proto.loopup.ctgateway.v2.RibbonSyncStatus}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getRibbonSyncStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.RibbonSyncStatus} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.RibbonSyncStatus} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.setRibbonSyncStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 18, value);
};


/**
 * optional google.protobuf.StringValue caller_id = 19;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getCallerId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 19));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
*/
proto.loopup.ctgateway.v2.CTNumber.prototype.setCallerId = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.clearCallerId = function() {
  return this.setCallerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.hasCallerId = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional google.protobuf.StringValue service_user_id = 20;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getServiceUserId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 20));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
*/
proto.loopup.ctgateway.v2.CTNumber.prototype.setServiceUserId = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.clearServiceUserId = function() {
  return this.setServiceUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.hasServiceUserId = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional UserType user_type = 21;
 * @return {!proto.loopup.ctgateway.v2.UserType}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getUserType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.UserType} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.UserType} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.setUserType = function(value) {
  return jspb.Message.setProto3EnumField(this, 21, value);
};


/**
 * optional google.protobuf.StringValue number_range = 22;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getNumberRange = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 22));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
*/
proto.loopup.ctgateway.v2.CTNumber.prototype.setNumberRange = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.clearNumberRange = function() {
  return this.setNumberRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.hasNumberRange = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.StringValue user_principal_name = 23;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getUserPrincipalName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 23));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
*/
proto.loopup.ctgateway.v2.CTNumber.prototype.setUserPrincipalName = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.clearUserPrincipalName = function() {
  return this.setUserPrincipalName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.hasUserPrincipalName = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional UsageType usage_type = 24;
 * @return {!proto.loopup.ctgateway.v2.UsageType}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getUsageType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.UsageType} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.UsageType} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.setUsageType = function(value) {
  return jspb.Message.setProto3EnumField(this, 24, value);
};


/**
 * optional google.protobuf.StringValue sip_trunk_name = 25;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.getSipTrunkName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 25));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
*/
proto.loopup.ctgateway.v2.CTNumber.prototype.setSipTrunkName = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.CTNumber} returns this
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.clearSipTrunkName = function() {
  return this.setSipTrunkName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.CTNumber.prototype.hasSipTrunkName = function() {
  return jspb.Message.getField(this, 25) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_ = [[3,4],[6,7],[9,10],[13,14],[19,20],[22,23],[26,27]];

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.AllocationStatusEnumCase = {
  ALLOCATION_STATUS_ENUM_NOT_SET: 0,
  ALLOCATION_STATUS_NULL: 3,
  ALLOCATION_STATUS: 4
};

/**
 * @return {proto.loopup.ctgateway.v2.NumberPendingChanges.AllocationStatusEnumCase}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getAllocationStatusEnumCase = function() {
  return /** @type {proto.loopup.ctgateway.v2.NumberPendingChanges.AllocationStatusEnumCase} */(jspb.Message.computeOneofCase(this, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.DdiNumberTypeEnumCase = {
  DDI_NUMBER_TYPE_ENUM_NOT_SET: 0,
  DDI_NUMBER_TYPE_NULL: 6,
  DDI_NUMBER_TYPE: 7
};

/**
 * @return {proto.loopup.ctgateway.v2.NumberPendingChanges.DdiNumberTypeEnumCase}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getDdiNumberTypeEnumCase = function() {
  return /** @type {proto.loopup.ctgateway.v2.NumberPendingChanges.DdiNumberTypeEnumCase} */(jspb.Message.computeOneofCase(this, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[1]));
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.HostTypeEnumCase = {
  HOST_TYPE_ENUM_NOT_SET: 0,
  HOST_TYPE_NULL: 9,
  HOST_TYPE: 10
};

/**
 * @return {proto.loopup.ctgateway.v2.NumberPendingChanges.HostTypeEnumCase}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getHostTypeEnumCase = function() {
  return /** @type {proto.loopup.ctgateway.v2.NumberPendingChanges.HostTypeEnumCase} */(jspb.Message.computeOneofCase(this, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[2]));
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.SupplierEnumCase = {
  SUPPLIER_ENUM_NOT_SET: 0,
  SUPPLIER_NULL: 13,
  SUPPLIER: 14
};

/**
 * @return {proto.loopup.ctgateway.v2.NumberPendingChanges.SupplierEnumCase}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getSupplierEnumCase = function() {
  return /** @type {proto.loopup.ctgateway.v2.NumberPendingChanges.SupplierEnumCase} */(jspb.Message.computeOneofCase(this, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[3]));
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.NumberStatusEnumCase = {
  NUMBER_STATUS_ENUM_NOT_SET: 0,
  NUMBER_STATUS_NULL: 19,
  NUMBER_STATUS: 20
};

/**
 * @return {proto.loopup.ctgateway.v2.NumberPendingChanges.NumberStatusEnumCase}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getNumberStatusEnumCase = function() {
  return /** @type {proto.loopup.ctgateway.v2.NumberPendingChanges.NumberStatusEnumCase} */(jspb.Message.computeOneofCase(this, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[4]));
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.UserTypeEnumCase = {
  USER_TYPE_ENUM_NOT_SET: 0,
  USER_TYPE_NULL: 22,
  USER_TYPE: 23
};

/**
 * @return {proto.loopup.ctgateway.v2.NumberPendingChanges.UserTypeEnumCase}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getUserTypeEnumCase = function() {
  return /** @type {proto.loopup.ctgateway.v2.NumberPendingChanges.UserTypeEnumCase} */(jspb.Message.computeOneofCase(this, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[5]));
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.UsageTypeEnumCase = {
  USAGE_TYPE_ENUM_NOT_SET: 0,
  USAGE_TYPE_NULL: 26,
  USAGE_TYPE: 27
};

/**
 * @return {proto.loopup.ctgateway.v2.NumberPendingChanges.UsageTypeEnumCase}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getUsageTypeEnumCase = function() {
  return /** @type {proto.loopup.ctgateway.v2.NumberPendingChanges.UsageTypeEnumCase} */(jspb.Message.computeOneofCase(this, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[6]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.NumberPendingChanges.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.NumberPendingChanges} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.toObject = function(includeInstance, msg) {
  var f, obj = {
    ddi: jspb.Message.getFieldWithDefault(msg, 1, ""),
    action: (f = msg.getAction()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    allocationStatusNull: jspb.Message.getFieldWithDefault(msg, 3, 0),
    allocationStatus: jspb.Message.getFieldWithDefault(msg, 4, 0),
    countryCode: (f = msg.getCountryCode()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    ddiNumberTypeNull: jspb.Message.getFieldWithDefault(msg, 6, 0),
    ddiNumberType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    assignedUserName: (f = msg.getAssignedUserName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    hostTypeNull: jspb.Message.getFieldWithDefault(msg, 9, 0),
    hostType: jspb.Message.getFieldWithDefault(msg, 10, 0),
    numberOwnedByLoopUp: (f = msg.getNumberOwnedByLoopUp()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    leadNumber: (f = msg.getLeadNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    supplierNull: jspb.Message.getFieldWithDefault(msg, 13, 0),
    supplier: jspb.Message.getFieldWithDefault(msg, 14, 0),
    siteName: (f = msg.getSiteName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    siteId: (f = msg.getSiteId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    customerName: (f = msg.getCustomerName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    customerId: (f = msg.getCustomerId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    numberStatusNull: jspb.Message.getFieldWithDefault(msg, 19, 0),
    numberStatus: jspb.Message.getFieldWithDefault(msg, 20, 0),
    drNumber: (f = msg.getDrNumber()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    userTypeNull: jspb.Message.getFieldWithDefault(msg, 22, 0),
    userType: jspb.Message.getFieldWithDefault(msg, 23, 0),
    numberRange: (f = msg.getNumberRange()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    userPrincipalName: (f = msg.getUserPrincipalName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    usageTypeNull: jspb.Message.getFieldWithDefault(msg, 26, 0),
    usageType: jspb.Message.getFieldWithDefault(msg, 27, 0),
    lastEventNumber: jspb.Message.getFieldWithDefault(msg, 28, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.NumberPendingChanges;
  return proto.loopup.ctgateway.v2.NumberPendingChanges.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.NumberPendingChanges} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDdi(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAction(value);
      break;
    case 3:
      var value = /** @type {!proto.google.protobuf.NullValue} */ (reader.readEnum());
      msg.setAllocationStatusNull(value);
      break;
    case 4:
      var value = /** @type {!proto.loopup.ctgateway.v2.CTAllocationStatus} */ (reader.readEnum());
      msg.setAllocationStatus(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCountryCode(value);
      break;
    case 6:
      var value = /** @type {!proto.google.protobuf.NullValue} */ (reader.readEnum());
      msg.setDdiNumberTypeNull(value);
      break;
    case 7:
      var value = /** @type {!proto.loopup.ctgateway.v2.CTNumberType} */ (reader.readEnum());
      msg.setDdiNumberType(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAssignedUserName(value);
      break;
    case 9:
      var value = /** @type {!proto.google.protobuf.NullValue} */ (reader.readEnum());
      msg.setHostTypeNull(value);
      break;
    case 10:
      var value = /** @type {!proto.loopup.ctgateway.v2.HostType} */ (reader.readEnum());
      msg.setHostType(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setNumberOwnedByLoopUp(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setLeadNumber(value);
      break;
    case 13:
      var value = /** @type {!proto.google.protobuf.NullValue} */ (reader.readEnum());
      msg.setSupplierNull(value);
      break;
    case 14:
      var value = /** @type {!proto.loopup.ctgateway.v2.Supplier} */ (reader.readEnum());
      msg.setSupplier(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSiteName(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSiteId(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomerName(value);
      break;
    case 18:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCustomerId(value);
      break;
    case 19:
      var value = /** @type {!proto.google.protobuf.NullValue} */ (reader.readEnum());
      msg.setNumberStatusNull(value);
      break;
    case 20:
      var value = /** @type {!proto.loopup.ctgateway.v2.NumberStatus} */ (reader.readEnum());
      msg.setNumberStatus(value);
      break;
    case 21:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDrNumber(value);
      break;
    case 22:
      var value = /** @type {!proto.google.protobuf.NullValue} */ (reader.readEnum());
      msg.setUserTypeNull(value);
      break;
    case 23:
      var value = /** @type {!proto.loopup.ctgateway.v2.UserType} */ (reader.readEnum());
      msg.setUserType(value);
      break;
    case 24:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setNumberRange(value);
      break;
    case 25:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setUserPrincipalName(value);
      break;
    case 26:
      var value = /** @type {!proto.google.protobuf.NullValue} */ (reader.readEnum());
      msg.setUsageTypeNull(value);
      break;
    case 27:
      var value = /** @type {!proto.loopup.ctgateway.v2.UsageType} */ (reader.readEnum());
      msg.setUsageType(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLastEventNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.NumberPendingChanges.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.NumberPendingChanges} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDdi();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAction();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {!proto.loopup.ctgateway.v2.CTAllocationStatus} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCountryCode();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = /** @type {!proto.loopup.ctgateway.v2.CTNumberType} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getAssignedUserName();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = /** @type {!proto.loopup.ctgateway.v2.HostType} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getNumberOwnedByLoopUp();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getLeadNumber();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = /** @type {!proto.loopup.ctgateway.v2.Supplier} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getSiteName();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSiteId();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomerName();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCustomerId();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = /** @type {!proto.loopup.ctgateway.v2.NumberStatus} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getDrNumber();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeEnum(
      22,
      f
    );
  }
  f = /** @type {!proto.loopup.ctgateway.v2.UserType} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeEnum(
      23,
      f
    );
  }
  f = message.getNumberRange();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getUserPrincipalName();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getField(message, 26));
  if (f != null) {
    writer.writeEnum(
      26,
      f
    );
  }
  f = /** @type {!proto.loopup.ctgateway.v2.UsageType} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeEnum(
      27,
      f
    );
  }
  f = message.getLastEventNumber();
  if (f !== 0) {
    writer.writeInt32(
      28,
      f
    );
  }
};


/**
 * optional string ddi = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getDdi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setDdi = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue action = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getAction = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
*/
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setAction = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearAction = function() {
  return this.setAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasAction = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.NullValue allocation_status_null = 3;
 * @return {!proto.google.protobuf.NullValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getAllocationStatusNull = function() {
  return /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.google.protobuf.NullValue} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setAllocationStatusNull = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearAllocationStatusNull = function() {
  return jspb.Message.setOneofField(this, 3, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasAllocationStatusNull = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional CTAllocationStatus allocation_status = 4;
 * @return {!proto.loopup.ctgateway.v2.CTAllocationStatus}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getAllocationStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.CTAllocationStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.CTAllocationStatus} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setAllocationStatus = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearAllocationStatus = function() {
  return jspb.Message.setOneofField(this, 4, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasAllocationStatus = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue country_code = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getCountryCode = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
*/
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setCountryCode = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearCountryCode = function() {
  return this.setCountryCode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasCountryCode = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.NullValue ddi_number_type_null = 6;
 * @return {!proto.google.protobuf.NullValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getDdiNumberTypeNull = function() {
  return /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.google.protobuf.NullValue} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setDdiNumberTypeNull = function(value) {
  return jspb.Message.setOneofField(this, 6, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearDdiNumberTypeNull = function() {
  return jspb.Message.setOneofField(this, 6, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasDdiNumberTypeNull = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional CTNumberType ddi_number_type = 7;
 * @return {!proto.loopup.ctgateway.v2.CTNumberType}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getDdiNumberType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.CTNumberType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.CTNumberType} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setDdiNumberType = function(value) {
  return jspb.Message.setOneofField(this, 7, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearDdiNumberType = function() {
  return jspb.Message.setOneofField(this, 7, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasDdiNumberType = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.StringValue assigned_user_name = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getAssignedUserName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
*/
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setAssignedUserName = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearAssignedUserName = function() {
  return this.setAssignedUserName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasAssignedUserName = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.NullValue host_type_null = 9;
 * @return {!proto.google.protobuf.NullValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getHostTypeNull = function() {
  return /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.google.protobuf.NullValue} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setHostTypeNull = function(value) {
  return jspb.Message.setOneofField(this, 9, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearHostTypeNull = function() {
  return jspb.Message.setOneofField(this, 9, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasHostTypeNull = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional HostType host_type = 10;
 * @return {!proto.loopup.ctgateway.v2.HostType}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getHostType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.HostType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.HostType} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setHostType = function(value) {
  return jspb.Message.setOneofField(this, 10, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearHostType = function() {
  return jspb.Message.setOneofField(this, 10, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasHostType = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.BoolValue number_owned_by_loop_up = 11;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getNumberOwnedByLoopUp = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 11));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
*/
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setNumberOwnedByLoopUp = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearNumberOwnedByLoopUp = function() {
  return this.setNumberOwnedByLoopUp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasNumberOwnedByLoopUp = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue lead_number = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getLeadNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
*/
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setLeadNumber = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearLeadNumber = function() {
  return this.setLeadNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasLeadNumber = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.NullValue supplier_null = 13;
 * @return {!proto.google.protobuf.NullValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getSupplierNull = function() {
  return /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.google.protobuf.NullValue} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setSupplierNull = function(value) {
  return jspb.Message.setOneofField(this, 13, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[3], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearSupplierNull = function() {
  return jspb.Message.setOneofField(this, 13, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[3], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasSupplierNull = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional Supplier supplier = 14;
 * @return {!proto.loopup.ctgateway.v2.Supplier}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getSupplier = function() {
  return /** @type {!proto.loopup.ctgateway.v2.Supplier} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.Supplier} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setSupplier = function(value) {
  return jspb.Message.setOneofField(this, 14, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[3], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearSupplier = function() {
  return jspb.Message.setOneofField(this, 14, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[3], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasSupplier = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.StringValue site_name = 15;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getSiteName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 15));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
*/
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setSiteName = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearSiteName = function() {
  return this.setSiteName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasSiteName = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.StringValue site_id = 16;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getSiteId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 16));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
*/
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setSiteId = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearSiteId = function() {
  return this.setSiteId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasSiteId = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.StringValue customer_name = 17;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getCustomerName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 17));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
*/
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setCustomerName = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearCustomerName = function() {
  return this.setCustomerName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasCustomerName = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.StringValue customer_id = 18;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getCustomerId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 18));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
*/
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setCustomerId = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearCustomerId = function() {
  return this.setCustomerId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasCustomerId = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional google.protobuf.NullValue number_status_null = 19;
 * @return {!proto.google.protobuf.NullValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getNumberStatusNull = function() {
  return /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.google.protobuf.NullValue} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setNumberStatusNull = function(value) {
  return jspb.Message.setOneofField(this, 19, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[4], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearNumberStatusNull = function() {
  return jspb.Message.setOneofField(this, 19, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[4], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasNumberStatusNull = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional NumberStatus number_status = 20;
 * @return {!proto.loopup.ctgateway.v2.NumberStatus}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getNumberStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.NumberStatus} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.NumberStatus} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setNumberStatus = function(value) {
  return jspb.Message.setOneofField(this, 20, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[4], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearNumberStatus = function() {
  return jspb.Message.setOneofField(this, 20, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[4], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasNumberStatus = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional google.protobuf.StringValue dr_number = 21;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getDrNumber = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 21));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
*/
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setDrNumber = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearDrNumber = function() {
  return this.setDrNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasDrNumber = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.NullValue user_type_null = 22;
 * @return {!proto.google.protobuf.NullValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getUserTypeNull = function() {
  return /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {!proto.google.protobuf.NullValue} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setUserTypeNull = function(value) {
  return jspb.Message.setOneofField(this, 22, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[5], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearUserTypeNull = function() {
  return jspb.Message.setOneofField(this, 22, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[5], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasUserTypeNull = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional UserType user_type = 23;
 * @return {!proto.loopup.ctgateway.v2.UserType}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getUserType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.UserType} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.UserType} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setUserType = function(value) {
  return jspb.Message.setOneofField(this, 23, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[5], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearUserType = function() {
  return jspb.Message.setOneofField(this, 23, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[5], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasUserType = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.StringValue number_range = 24;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getNumberRange = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 24));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
*/
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setNumberRange = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearNumberRange = function() {
  return this.setNumberRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasNumberRange = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional google.protobuf.StringValue user_principal_name = 25;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getUserPrincipalName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 25));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
*/
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setUserPrincipalName = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearUserPrincipalName = function() {
  return this.setUserPrincipalName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasUserPrincipalName = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional google.protobuf.NullValue usage_type_null = 26;
 * @return {!proto.google.protobuf.NullValue}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getUsageTypeNull = function() {
  return /** @type {!proto.google.protobuf.NullValue} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {!proto.google.protobuf.NullValue} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setUsageTypeNull = function(value) {
  return jspb.Message.setOneofField(this, 26, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[6], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearUsageTypeNull = function() {
  return jspb.Message.setOneofField(this, 26, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[6], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasUsageTypeNull = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional UsageType usage_type = 27;
 * @return {!proto.loopup.ctgateway.v2.UsageType}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getUsageType = function() {
  return /** @type {!proto.loopup.ctgateway.v2.UsageType} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.UsageType} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setUsageType = function(value) {
  return jspb.Message.setOneofField(this, 27, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[6], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.clearUsageType = function() {
  return jspb.Message.setOneofField(this, 27, proto.loopup.ctgateway.v2.NumberPendingChanges.oneofGroups_[6], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.hasUsageType = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional int32 last_event_number = 28;
 * @return {number}
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.getLastEventNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {number} value
 * @return {!proto.loopup.ctgateway.v2.NumberPendingChanges} returns this
 */
proto.loopup.ctgateway.v2.NumberPendingChanges.prototype.setLastEventNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 28, value);
};


/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.AllocationStatus = {
  ALLOCATION_STATUS_INVALID: 0,
  ALLOCATION_STATUS_ALLOCATED: 1,
  ALLOCATION_STATUS_UNALLOCATED: 2,
  ALLOCATION_STATUS_NOT_APPLICABLE: 3,
  ALLOCATION_STATUS_PENDING: 4,
  ALLOCATION_STATUS_RESERVED: 5
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.CTAllocationStatus = {
  CT_ALLOCATION_STATUS_INVALID: 0,
  CT_ALLOCATION_STATUS_ALLOCATED: 1,
  CT_ALLOCATION_STATUS_NOT_APPLICABLE: 2,
  CT_ALLOCATION_STATUS_UNALLOCATED: 3,
  CT_ALLOCATION_STATUS_UNKNOWN: 4,
  CT_ALLOCATION_STATUS_RESERVED: 5,
  CT_ALLOCATION_STATUS_PENDING: 6
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.NumberType = {
  NUMBER_TYPE_INVALID: 0,
  NUMBER_TYPE_GEOGRAPHICAL: 1,
  NUMBER_TYPE_NON_GEOGRAPHICAL: 2
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.CTNumberType = {
  CT_NUMBER_TYPE_INVALID: 0,
  CT_NUMBER_TYPE_GEOGRAPHICAL: 1,
  CT_NUMBER_TYPE_NOT_APPLICABLE: 2,
  CT_NUMBER_TYPE_NON_GEOGRAPHICAL: 3,
  CT_NUMBER_TYPE_UNKNOWN: 4
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.HostType = {
  HOST_TYPE_INVALID: 0,
  HOST_TYPE_HOSTED: 1,
  HOST_TYPE_ON_PREM: 2,
  HOST_TYPE_UNKNOWN: 3,
  HOST_TYPE_TEAMS_OC: 5,
  HOST_TYPE_LMZ: 6,
  HOST_TYPE_SIP: 7,
  HOST_TYPE_FORWARD_ONLY: 8,
  HOST_TYPE_NONE: 9
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.Supplier = {
  SUPPLIER_INVALID: 0,
  SUPPLIER_COLT: 1,
  SUPPLIER_DAISY: 2,
  SUPPLIER_GAMMA: 3,
  SUPPLIER_NOT_APPLICABLE: 4,
  SUPPLIER_PCCW: 5,
  SUPPLIER_PURE_IP: 6,
  SUPPLIER_SYMBIO: 7,
  SUPPLIER_UNKNOWN: 8,
  SUPPLIER_VOIP_UNLIMITED: 9,
  SUPPLIER_BANDWIDTH: 10,
  SUPPLIER_BICS: 11,
  SUPPLIER_CHINA_MOBILE: 12,
  SUPPLIER_ORANGE: 13,
  SUPPLIER_PEERLESS: 14,
  SUPPLIER_TATA: 15,
  SUPPLIER_TELEFONICA: 16,
  SUPPLIER_VOXBONE: 17,
  SUPPLIER_VTS: 18,
  SUPPLIER_GAMA_INBOUND: 19,
  SUPPLIER_LUMEN: 20,
  SUPPLIER_M800: 21,
  SUPPLIER_ICT_GLOBE: 22,
  SUPPLIER_ROITEL: 23,
  SUPPLIER_NOT_OUR_CARRIER: 24,
  SUPPLIER_DIGICEL: 25,
  SUPPLIER_AVOXI: 26
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.UserType = {
  USER_TYPE_INVALID: 0,
  USER_TYPE_AUTO_ATTENDANT: 1,
  USER_TYPE_CALL_QUEUES: 2,
  USER_TYPE_COM_AREA_PHONE: 3,
  USER_TYPE_MEETING_ROOM: 4,
  USER_TYPE_NOT_APPLICABLE: 5,
  USER_TYPE_UNKNOWN: 6,
  USER_TYPE_USER: 7
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.NumberStatus = {
  NUMBER_STATUS_INVALID: 0,
  NUMBER_STATUS_ACTIVE: 1,
  NUMBER_STATUS_DELETED: 2,
  NUMBER_STATUS_INACTIVE: 3,
  NUMBER_STATUS_CEASED: 4,
  NUMBER_STATUS_PENDING_PORTING_AWAY: 5,
  NUMBER_STATUS_PENDING_PORTING_IN: 6,
  NUMBER_STATUS_UNKNOWN: 7
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.OculeusSyncStatus = {
  OCULEUS_SYNC_STATUS_INVALID: 0,
  OCULEUS_SYNC_STATUS_ADDED: 1,
  OCULEUS_SYNC_STATUS_DELETED: 2,
  OCULEUS_SYNC_STATUS_FAILED_TO_ADD: 3,
  OCULEUS_SYNC_STATUS_FAILED_TO_DELETE: 4,
  OCULEUS_SYNC_STATUS_FAILED_TO_UPDATE: 5,
  OCULEUS_SYNC_STATUS_NOT_APPLICABLE: 6,
  OCULEUS_SYNC_STATUS_PENDING: 7,
  OCULEUS_SYNC_STATUS_UPDATED: 8
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.RibbonSyncStatus = {
  RIBBON_SYNC_STATUS_INVALID: 0,
  RIBBON_SYNC_STATUS_NOT_SYNCED: 1,
  RIBBON_SYNC_STATUS_FAILED: 2,
  RIBBON_SYNC_STATUS_PARTIAL: 3,
  RIBBON_SYNC_STATUS_SYNC_COMPLETED: 4
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.DDISortProperty = {
  DDI_SORT_PROPERTY_INVALID: 0,
  DDI_SORT_PROPERTY_DDI: 1,
  DDI_SORT_PROPERTY_ALLOCATION_STATUS: 2,
  DDI_SORT_PROPERTY_CITY: 3,
  DDI_SORT_PROPERTY_COUNTRY_CODE: 4,
  DDI_SORT_PROPERTY_SITE: 5,
  DDI_SORT_PROPERTY_GEOGRAPHICAL_TYPE: 6,
  DDI_SORT_PROPERTY_ASSIGNED_USER_NAME: 7
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.CTNumberSortProperty = {
  CT_NUMBER_SORT_PROPERTY_INVALID: 0,
  CT_NUMBER_SORT_PROPERTY_DDI: 1,
  CT_NUMBER_SORT_PROPERTY_ALLOCATION_STATUS: 2,
  CT_NUMBER_SORT_PROPERTY_USER: 3,
  CT_NUMBER_SORT_PROPERTY_UPN: 4,
  CT_NUMBER_SORT_PROPERTY_CITY: 5,
  CT_NUMBER_SORT_PROPERTY_COUNTRY_CODE: 6,
  CT_NUMBER_SORT_PROPERTY_SITE: 7,
  CT_NUMBER_SORT_PROPERTY_GEOGRAPHY_TYPE: 8,
  CT_NUMBER_SORT_PROPERTY_COUNTRY_NAME: 9
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.CTNumberSortDirection = {
  CT_NUMBER_SORT_DIRECTION_INVALID: 0,
  CT_NUMBER_SORT_DIRECTION_ASC: 1,
  CT_NUMBER_SORT_DIRECTION_DESC: 2
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.UsageType = {
  USAGE_TYPE_INVALID: 0,
  USAGE_TYPE_FIRST_PARTY_APP_ASSIGNMENT: 1,
  USAGE_TYPE_CALLING_USER_ASSIGNMENT: 2,
  USAGE_TYPE_FIRST_PARTY_APP_ASSIGNMENT_AND_CALLING_USER_ASSIGNMENT: 3
};

goog.object.extend(exports, proto.loopup.ctgateway.v2);
